import { useErrorMapping } from 'framework/form';
import { FieldProps, useFieldHelper } from 'framework/ui/field';
import { useUiTheme } from 'framework/uiTheme';

const BusinessRulesListField = (props: FieldProps<any[]>) => {
  const { getValue, getLabel } = useFieldHelper(props);
  const { BaseFieldLayout } = useUiTheme();
  const { errorMap } = props;
  const { mapErrorMessage } = useErrorMapping(errorMap);

  const violatedRules = getValue() || [];
  const validViolatedRules = violatedRules.filter((rule): rule is string => typeof rule === 'string' && !!rule.trim());

  const uniqueViolatedRules = [...new Set(validViolatedRules)];

  const displayedRules = (
    <ul style={{ margin: 0, paddingLeft: 2 }}>
      {uniqueViolatedRules.map(rule => (
        <li key={rule}>{mapErrorMessage(rule)}</li>
      ))}
    </ul>
  );

  return <BaseFieldLayout label={getLabel()} value={displayedRules} isColumnDirection={uniqueViolatedRules.length} />;
};

export default BusinessRulesListField;
